export default {
  'rechargelog.currency_type.1': '钻石',
  'rechargelog.currency_type.2': '金币',

  'rechargelog.op_type.1': '充值',
  'rechargelog.op_type.2': '扣除',
  'rechargelog.op_type.3': '兑换',
  'rechargelog.op_type.null': '',

  'rechargelog.sub_op_type.1': '常规充值',
  'rechargelog.sub_op_type.2': '福利充值',
  'rechargelog.sub_op_type.3': '自己充值',
  'rechargelog.sub_op_type.4': '退款补款其它',
  'rechargelog.sub_op_type.5': '超管月末返利',
  'rechargelog.sub_op_type.6': 'VIP等级福利',
  'rechargelog.sub_op_type.7': '金币兑换钻石',
  'rechargelog.sub_op_type.8': '金币兑换钻石',
  'rechargelog.sub_op_type.null': '',
};
